interface SectionHeadingProps {
  id?: string;
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  level?: 'h2' | 'h3';
}

export default function SectionHeading({
  id,
  eyebrow,
  title,
  desc,
  align = 'left',
  level = 'h2',
}: SectionHeadingProps) {
  const Tag = level;
  return (
    <div className={align === 'center' ? 'max-w-2xl mx-auto text-center' : 'max-w-2xl'}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase mb-3">
          <span className="w-6 h-px bg-primary-400" />
          {eyebrow}
        </span>
      )}
      <Tag id={id} className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </Tag>
      {desc && <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
    </div>
  );
}